import classNames from 'classnames';
import React from 'react';
import FadeIn from 'react-fade-in';
import { createUseStyles } from 'react-jss';
import { layoutDefaults } from '../../utils/layout-defaults';
import { PrivacyNotice } from '../privacy-notice';

function SelectPaymentCardModalTitle({
  title,
  subTitle,
  className,
  style,
  getPrivacyPolicyFromRemote,
  analytics,
}) {
  const classes = useStyles({ subTitle });

  return (
    <div className={classNames(classes.container, className)} style={style}>
      <FadeIn delay={150}>
        <div className={classes.title}>{title}</div>
      </FadeIn>
      <FadeIn delay={200}>
        <PrivacyNotice
          analytics={analytics}
          getPrivacyPolicyFromRemote={getPrivacyPolicyFromRemote}
        />
      </FadeIn>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    marginLeft: layoutDefaults.smallHorizontalMargin,
    marginRight: layoutDefaults.smallHorizontalMargin,
    // border: "1px solid white",
  },
  title: {
    fontSize: layoutDefaults.biggestFontSize,
    fontWeight: 'bold',
    marginTop: -layoutDefaults.bigVerticalMargin,
  },
  subTitle: {
    fontSize: ({ subTitle }) =>
      (subTitle?.length ?? 0) < 10
        ? layoutDefaults.biggestFontSize
        : layoutDefaults.biggerFontSize,
  },
});

export { SelectPaymentCardModalTitle };
